import React, { useEffect, useState } from 'react'
import {Box, Flex, Grid, GridItem, Heading, Input, Select, Spacer, Text, Tab, TabList, TabPanel, TabPanels, Tabs, Divider} from '@chakra-ui/react'
import NavBar from '../../../../elements/NavBar'
import {useHistory} from 'react-router-dom'
import * as routesNames from '../../../../../constants/routes'
import { removeAll } from '../../../../../utilities/authUtils'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActionCreators } from '../../../../../redux/actions'
import CustomButton from '../../../../elements/customButton'
import Loader from '../../../../elements/loader'
import moment from 'moment'
import CustomToast from '../../../../elements/customToast'
import apiInstance from '../../../../../config/api/axios'
import { APIPATH } from '../../../../../constants/Constant'

const reportType = [
    {
        id: 1,
        name: 'RBI Report',
    },
]

const tabNames = [
  {
      id: 1,
      name: 'RBI Report',
  },
 
]

const RBIReport = (props) => {
  const [isLoading, setIsLoading] = useState(false)
    const { addToast } = CustomToast()
    const adminState = useSelector((state) => state.adminState)
    const reportState = useSelector((state) => state.reportState)
    const [inputValues, setInputValues] = useState({})
    const userData = adminState?.getUserByToken?.data?.data

    useEffect(() => {
      props?.actions?.getUserByTokenAction()
      const today = moment(new Date()).format('YYYY-MM-DD')
      setInputValues({
        current_start_date: today,
        current_end_date: today,
        previous_start_date: today,
        previous_end_date: today,
      });
    }, [])

    const handleChange = (e) => {
      const { name, value } = e.target;
      if (name === 'report_type') {
        const selectedReport = reportType.find(report => report.value === value);
        if (selectedReport) {
          setInputValues({...inputValues, [name]: value, member_short_name: selectedReport.member_short_name})
        }
      } else {
        setInputValues({...inputValues, [name]: value})
      }
    }
    const handleGenerateReport = () => {
      const { previous_start_date, previous_end_date, current_start_date, current_end_date } = inputValues;
      setIsLoading(true)
      // Validate the first date range
      if (!moment(previous_start_date).isSameOrBefore(previous_end_date)) {
        addToast({ message: 'Previous Start Date must be before or the same as Previous End Date', status: 'error' });
        return;
      }
    
      // Validate the second date range
      if (!moment(current_start_date).isSameOrBefore(current_end_date)) {
        addToast({ message: 'Start Date must be before or the same as End Date', status: 'error' });
        return;
      }
    
      // Proceed with API call if validations pass
      apiInstance.post(`${APIPATH}/getRBIReportByDate`, inputValues, {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
      })
   
        .then(async (res) => {
          setIsLoading(false)
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'RBIReport.xlsx');
          link.onload = () => {
            window.URL.revokeObjectURL(url);
          };
          link.click();
        })
        .catch((err) => {
          addToast({ message: 'Error generating report', status: 'error' });
        });
    };
    
  return (
    <>
      {(adminState?.getUserByToken?.loading || reportState?.getActiveMultipleEmiPayment?.loading || reportState?.getClosedMultipleEmiPayment?.loading || isLoading) &&
        <div>
            <Loader />
        </div>
      }
      <Box className='dashboard_box bg_shadow'>
          <Grid className="main_grid_container align-items-center">
              <GridItem colSpan={8}>
                  <Heading as="h2" className='font-poppins page_heading'>RBI Report</Heading>
              </GridItem>
              <GridItem colSpan={4}>
                  <NavBar data={userData} isAdmin />
              </GridItem>
          </Grid>
          <Grid className="main_grid_container" mb={4} mt={7} gap={7}>
            <GridItem colSpan={6}>
              <Box mt={3}>
                <CustomButton size="md" type="submit" title="Generate Report" className="font-poppins btn_theme" onClick={handleGenerateReport} />
              </Box>
            </GridItem>
            <GridItem colSpan={6}>
              <Flex alignItems='center' justifyContent='space-between' gap={2} className='custom_select'>
                <Box className='select_report_type'>
                  <Text className="font-poppins">Previous Start Date</Text>
                  <Input size="md" name="previous_start_date"  type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                      onChange={handleChange} value={inputValues?.previous_start_date ?? ''} max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                </Box>
                <Spacer />
                <Box className='select_report_type'>
                  <Text className="font-poppins">Previous End Date</Text>
                  <Input size="md" name="previous_end_date"  type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                      onChange={handleChange} value={inputValues?.previous_end_date ?? ''} max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                </Box>
              </Flex>
              
            </GridItem>
            <GridItem colSpan={6}>
              <Flex alignItems='center' justifyContent='space-between' gap={2} className='custom_select'>
                <Box className='select_report_type'>
                  <Text className="font-poppins">From Date</Text>
                  <Input size="md" name="current_start_date"  type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                      onChange={handleChange} value={inputValues?.current_start_date ?? ''} max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                </Box>
                <Spacer />
                <Box className='select_report_type'>
                  <Text className="font-poppins">To Date</Text>
                  <Input size="md" name="current_end_date"  type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                      onChange={handleChange} value={inputValues?.current_end_date ?? ''} max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                </Box>
              </Flex>
              
            </GridItem>
          </Grid>
          <Divider />
      </Box>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(RBIReport)